export const getLabelsByInstituteType = (instituteType) => {
  let Department, Class, Section, Depth, Type;

  if (instituteType?.toLowerCase() === 'school') {
    Department = 'Class';
    Class = 'Section';
    Section = '';
    Depth = 2;
    Type = 'School';
  } else if (instituteType?.toLowerCase() === 'college') {
    Department = 'Department';
    Class = 'Year';
    Section = 'Section';
    Depth = 3;
    Type = 'College';
  } else {
    Department = 'Department';
    Class = 'Class/Section';
    Section = '';
    Depth = 2;
    Type = 'College';
  }

  return { Department, Class, Section, Depth, Type };
};
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
    },
  },
};
